"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgIcon = _interopRequireDefault(require("../../components/SvgIcon"));
var _default = exports["default"] = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], Object.assign({
    viewBox: '0 0 16 16'
  }, props, {
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: 'currentColor'
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.5,16 C0.672666667,16 0,15.3273333 0,14.5 L0,3.5 C0,2.67266667 0.672666667,2 1.5,2 L4,2 L4,0.5 C4,0.224 4.224,0 4.5,0 C4.776,0 5,0.224 5,0.5 L5,2 L11,2 L11,0.5 C11,0.224 11.224,0 11.5,0 C11.776,0 12,0.224 12,0.5 L12,2 L14.5,2 C15.3273333,2 16,2.67266667 16,3.5 L16,14.5 C16,15.3273333 15.3273333,16 14.5,16 L1.5,16 Z M1,14.5 C1,14.776 1.224,15 1.5,15 L14.5,15 C14.776,15 15,14.776 15,14.5 L15,7 L1,7 L1,14.5 Z M15,6 L15,3.5 C15,3.224 14.776,3 14.5,3 L12,3 L12,4 C12,4.276 11.776,4.5 11.5,4.5 C11.224,4.5 11,4.276 11,4 L11,3 L5,3 L5,4 C5,4.276 4.776,4.5 4.5,4.5 C4.224,4.5 4,4.276 4,4 L4,3 L1.5,3 C1.224,3 1,3.224 1,3.5 L1,6 L15,6 Z",
    id: "Shape"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "3.75",
    cy: "9.25",
    r: "1"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "3.75",
    cy: "12.75",
    r: "1"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "8",
    cy: "9.25",
    r: "1"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "8",
    cy: "12.75",
    r: "1"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "12.25",
    cy: "9.25",
    r: "1"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.25,13.5 C11.8366667,13.5 11.5,13.1633333 11.5,12.75 C11.5,12.3366667 11.8366667,12 12.25,12 C12.2593333,12 12.27,12.0006667 12.2806667,12.002 C12.2873333,12.0026667 12.2933333,12.0033333 12.2986667,12.004 C12.6873333,12.0233333 13,12.3513333 13,12.7506667 C13,13.1633333 12.6633333,13.5 12.25,13.5 Z"
  })));
});